import React from 'react';
import { IconProps } from '.';

const SvgColoredKeyword = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#A89FFF'
        d='m22.081 20.312-4.715-4.715a8.71 8.71 0 0 0 1.746-5.24c0-4.829-3.928-8.757-8.756-8.757S1.6 5.528 1.6 10.356s3.928 8.756 8.756 8.756a8.71 8.71 0 0 0 5.24-1.746l4.716 4.715a1.253 1.253 0 0 0 1.77-1.769Zm-17.98-9.956a6.254 6.254 0 1 1 6.255 6.254 6.262 6.262 0 0 1-6.254-6.254Z'
      />
      <circle cx={7.2} cy={10.4} r={0.8} fill='#604EDF' />
      <circle cx={10.4} cy={10.4} r={0.8} fill='#604EDF' />
      <circle cx={13.6} cy={10.4} r={0.8} fill='#604EDF' />
    </svg>
  );
};

export default SvgColoredKeyword;
